"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "form-padding relative" };
const _hoisted_2 = {
    class: "oplus-form-text",
    for: "role-name"
};
const _hoisted_3 = { class: "color-box-pos" };
const _hoisted_4 = { class: "role-form-color-text" };
const _hoisted_5 = { class: "form-padding" };
const _hoisted_6 = {
    class: "oplus-form-text",
    for: "role-purpose"
};
const _hoisted_7 = { class: "form-padding" };
const _hoisted_8 = { class: "oplus-form-checkbox" };
const _hoisted_9 = { class: "form-padding" };
const _hoisted_10 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "role-setting-header" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "oplus-form-text" }, "シフト表に表示(セクション)")
], -1 /* HOISTED */);
const _hoisted_11 = { class: "padding-top role-grid-wrapper" };
const _hoisted_12 = { class: "oplus-form-checkbox" };
const _hoisted_13 = { class: "form-padding role-form-footer" };
const ColorBox_vue_1 = __importDefault(require("../../vue/ColorBox.vue"));
const models_js_1 = require("../../js/models.js");
const vue_3 = require("vue");
const common_1 = require("../../common/common");
const common_2 = require("../../js/common");
const roles_1 = require("../../js/roles");
const roleSectionInjectionKeys_1 = require("../types/roleSectionInjectionKeys");
// Props
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleSectionForm',
    props: {
        isFormLoading: {
            default: false,
            type: Boolean
        }
    },
    emits: ["role-section-on-submit"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const selectedRole = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleViewSelectedRole, undefined);
        // Local data
        const colorBox = (0, vue_3.ref)(null); // this is getting the color-box element
        const data = (0, vue_3.ref)({
            isColorBoxVisible: false,
            isLoading: false,
            formData: {
                color: models_js_1.OPLUS_COLOR_PALETTE.DEFAULT,
                name: "",
                purpose: "",
                from: "",
                to: "",
                isRoleSection: true,
                showCount: true,
                isRestSection: false,
            },
        });
        // emits
        const emitNewRole = __emit;
        // Computed
        const submitButtonText = (0, vue_3.computed)(() => {
            return selectedRole?.value ? "編集" : "作成";
        });
        const selectedColorBox = (0, vue_3.computed)(() => {
            return data.value.formData.color;
        });
        const colorBoxStyle = (0, vue_3.computed)(() => {
            return {
                "backgroundColor": "#" + selectedColorBox.value,
                "borderColor": "#" + selectedColorBox.value
            };
        });
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": props.isFormLoading
            };
        });
        function populateDataFromProps() {
            if (selectedRole?.value) {
                const { formData } = data.value;
                formData.color = selectedRole.value.color;
                formData.name = selectedRole.value.getName();
                formData.purpose = selectedRole.value.purpose;
                formData.from = createRoleStringLabel(selectedRole.value.getStartHour(), selectedRole.value.getStartMinute());
                formData.to = createRoleStringLabel(selectedRole.value.getEndHour(), selectedRole.value.getEndMinute());
                formData.showCount = selectedRole.value.showCount ?? true;
                formData.isRestSection = selectedRole.value.isRestSection ?? false;
            }
        }
        function createRoleStringLabel(hour, minute) {
            const startHour = (0, common_2.addZeroPlaceholders)(hour);
            const startMinute = (0, common_2.addZeroPlaceholders)(minute);
            return `${startHour}:${startMinute}`;
        }
        function openColorBox() {
            data.value.isColorBoxVisible = true;
        }
        function setSelectedColor(colorStr) {
            data.value.formData.color = colorStr;
        }
        // Close color box outside click
        function handleRoleContainerClick(event) {
            const target = event.target;
            if (!colorBox.value?.contains(target)) {
                data.value.isColorBoxVisible = false;
            }
        }
        function handleRoleSectionSubmit() {
            if (props.isFormLoading) {
                return;
            }
            if (!data.value.formData.name) {
                (0, roles_1.openAlertModal)("「ラベル」を入力して下さい。");
                return;
            }
            const { color, name, from, to, purpose, showCount, isRestSection } = data.value.formData;
            const formDataColor = color === models_js_1.OPLUS_COLOR_PALETTE.DEFAULT ? "" : color;
            const formDataPurpose = (0, common_1.fullWidthToAscii)(purpose || "");
            const formDataFrom = (0, common_1.removeWhiteSpace)((0, common_1.fullWidthToAscii)(from || ""));
            const formDataTo = (0, common_1.removeWhiteSpace)((0, common_1.fullWidthToAscii)(to || ""));
            const formDataName = (0, common_1.fullWidthToAscii)(name);
            const formData = {
                color: formDataColor,
                name: formDataName,
                purpose: formDataPurpose,
                from: formDataFrom,
                to: formDataTo,
                isRoleSection: true,
                showCount: showCount,
                isRestSection: isRestSection,
            };
            const emitData = {
                roleId: selectedRole?.value?.getId() || "",
                formData: formData
            };
            emitNewRole('role-section-on-submit', emitData);
        }
        (0, vue_3.onMounted)(() => {
            populateDataFromProps();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("form", {
                onSubmit: _cache[6] || (_cache[6] = (0, vue_2.withModifiers)(($event) => (handleRoleSectionSubmit()), ["prevent"])),
                onClick: _cache[7] || (_cache[7] = ($event) => (handleRoleContainerClick($event)))
            }, [
                (0, vue_2.createElementVNode)("div", null, [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        (0, vue_2.createElementVNode)("label", _hoisted_2, [
                            (0, vue_2.createTextVNode)("ラベル (必須) "),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((data.value.formData.name) = $event)),
                                type: "text",
                                name: "role-name",
                                id: "",
                                placeholder: "業務名"
                            }, null, 512 /* NEED_PATCH */), [
                                [vue_2.vModelText, data.value.formData.name]
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createElementVNode)("div", {
                                    ref_key: "colorBox",
                                    ref: colorBox,
                                    class: "role-form-color-wrapper",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (openColorBox()))
                                }, [
                                    (0, vue_2.createElementVNode)("div", {
                                        class: "role-form-color-box",
                                        style: (0, vue_2.normalizeStyle)(colorBoxStyle.value)
                                    }, null, 4 /* STYLE */),
                                    (0, vue_2.createElementVNode)("span", _hoisted_4, [
                                        (0, vue_2.createTextVNode)("色塗り "),
                                        (0, vue_2.createVNode)(vue_2.Transition, { name: "slide-up" }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(ColorBox_vue_1.default, {
                                                    class: "oplus-color-box edit-form-role",
                                                    "selected-color": selectedColorBox.value,
                                                    "is-visible": data.value.isColorBoxVisible,
                                                    onColorSelect: setSelectedColor
                                                }, null, 8 /* PROPS */, ["selected-color", "is-visible"])
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ])
                                ], 512 /* NEED_PATCH */)
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.createElementVNode)("label", _hoisted_6, [
                            (0, vue_2.createTextVNode)(" 説明 "),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((data.value.formData.purpose) = $event)),
                                type: "text",
                                name: "role-purpose",
                                placeholder: "朝番, レジ"
                            }, null, 512 /* NEED_PATCH */), [
                                [vue_2.vModelText, data.value.formData.purpose]
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_7, [
                        (0, vue_2.createElementVNode)("label", _hoisted_8, [
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((data.value.formData.isRestSection) = $event)),
                                type: "checkbox",
                                id: "role-modal-is-rest"
                            }, null, 512 /* NEED_PATCH */), [
                                [vue_2.vModelCheckbox, data.value.formData.isRestSection]
                            ]),
                            (0, vue_2.createTextVNode)(" 休憩 ")
                        ])
                    ]),
                    (0, vue_2.createCommentVNode)(" Remove for now, according to design, disable the ability to input From and To of role sections "),
                    (0, vue_2.createCommentVNode)(" <div class=\"form-padding\">\n        <div class=\"role-grid-wrapper\" data-columns=\"2\">\n          <div>\n            <label class=\"oplus-form-text\" for=\"role-from\">\n              から\n              <input v-model=\"data.formData.from\" type=\"text\" name=\"role-from\" id=\"\" placeholder=\"10, 10:00, 1000\">\n            </label>\n          </div>\n\n          <div>\n            <label class=\"oplus-form-text\" for=\"role-to\">\n              まで\n              <input v-model=\"data.formData.to\" type=\"text\" name=\"role-to\" id=\"\" placeholder=\"18, 18:00, 1800\">\n            </label>\n          </div>\n        </div>\n      </div "),
                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                        _hoisted_10,
                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                            (0, vue_2.createElementVNode)("label", _hoisted_12, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((data.value.formData.showCount) = $event)),
                                    type: "checkbox",
                                    id: "role-modal-show-count"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, data.value.formData.showCount]
                                ]),
                                (0, vue_2.createTextVNode)(" カウント ")
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_13, [
                        (0, vue_2.createElementVNode)("button", {
                            onClick: _cache[5] || (_cache[5] = ($event) => (handleRoleSectionSubmit())),
                            class: (0, vue_2.normalizeClass)([loadingClass.value, "oplus-modal-btn oplus-confirm-btn"])
                        }, (0, vue_2.toDisplayString)(submitButtonText.value), 3 /* TEXT, CLASS */)
                    ])
                ])
            ], 32 /* NEED_HYDRATION */));
        };
    }
});
